import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';
import QAContent from '../components/QA/QAContent';

const QAPage = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('qa-page.qa-page-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language])

    return (
        <>
            <NavbarTop />
            <QAContent/>
        </>
    )
}

export default QAPage